module.exports = __webpack_public_path__ + "static/media/introduction-recibase_01.4eebee2c.jpg";